module.exports = __webpack_public_path__ + "img/4.e1571f07.jpg";